import { SerpDisplayType } from '~/analytics/ActionAnalytics/actions/actionTypes';
import { RequestParams } from '~/core/api/RequestTypes';
import { ResponseResult } from '~/core/api/ResponseTypes';
import { SERPEvent, SERPEventType } from '../SERPEvents';

export type SearchEventDetail = {
    data: {
        searchQuery: string;
        totalResultsCount: number;
        requestParams: RequestParams;
        results: Array<ResponseResult>;
        serpType: SerpDisplayType;
    };
};

export type SearchEvent = CustomEvent<SearchEventDetail> & {
    type: SERPEventType.SEARCH;
};

export const isSearchEvent = (event: SERPEvent): event is SearchEvent => {
    return (
        event.type === SERPEventType.SEARCH &&
        'data' in event.detail &&
        typeof event.detail.data === 'object' &&
        'searchQuery' in event.detail.data &&
        'totalResultsCount' in event.detail.data &&
        'requestParams' in event.detail.data &&
        'results' in event.detail.data
    );
};
